import { useRef } from "react"
import { NavLink } from "react-router-dom"

const NavBarNavLink = ({ to= "/", txt = "Un navlink de de la navbar", css = "", img = null, child = null }) => {

    const navLinkRef = useRef()
    const cssBtn = !child ? ({ isActive }) => `flexJustifyItemsCenter btn ${!isActive && "btn-inactive"} ${isActive && "btn-active cursor-auto"} ${css}` : `${css}`

    return(
        <NavLink ref={navLinkRef} to={to} className={cssBtn} >
            { child }
            { img && img }
            { !child && <span>{txt}</span> }
        </NavLink>
    )
}
   
export default NavBarNavLink